import { Injectable } from '@angular/core';
import { snakeCase } from 'lodash';
import { CurrentPlan } from '../../../features-data/sub-models/current-plan.model';
import { Settings } from '../../../settings-data/settings.model';
import { DateTimeService, MOMENT_TIMEZONELESS_DATE_FORMAT } from 'i2g-ng-utils';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class FeedbackDialogBuilder {
  constructor(private _dateTimeService: DateTimeService) {}

  buildDefaultTags(
    browserName: string,
    currentPlan: CurrentPlan,
    userEmail: string,
    browserLocale: string,
    settings: Settings,
    accountId: string
  ): string[] {
    return [
      `browser_${browserName}`,
      `app_version_${environment.version}`,
      `subscription_type_${currentPlan.planName}`,
      `email_address_${userEmail}`,
      `system_locale_${browserLocale}`,
      `account_language_${settings.documentLocale}`,
      `account_country_${settings.companySettings.country}`,
      `account_currency_${settings.documentCurrencyCode}`,
      `card_payments_enabled_${settings.payments.cardPaymentsEnabled()}`,
      `paypal_ec_enabled_${settings.payments.paypalEcEnabled}`,
      `account_id_${accountId}`,
      `expiration_date_${this._dateTimeService.formatDate(
        currentPlan.expiryDateUtc,
        MOMENT_TIMEZONELESS_DATE_FORMAT,
        true
      )}`,
    ].map((val: string) => snakeCase(val));
  }
}
